'use client';
import { AgreementSampleScenario, agreementSampleScenarios } from 'bff';
import { useTranslations } from 'i11n';
import { useCallback } from 'react';
import {
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'ui';

/**
 * Con qué ofrecimiento de ejemplo se previsualiza una plantilla. Las cuatro
 * combinaciones de cuotas × abogado salen del mismo fixture que resuelven los
 * specs, así que el editor de cartas y el de conformidades muestran lo mismo.
 */
export const AgreementSampleScenarioSelect = ({
  value,
  onChange,
}: {
  value: AgreementSampleScenario;
  onChange: (scenario: AgreementSampleScenario) => void;
}) => {
  const t = useTranslations('agreementTemplates.editor');

  const handleChange = useCallback(
    (next: string) => onChange(next as AgreementSampleScenario),
    [onChange],
  );

  return (
    <div className='space-y-1'>
      <Label>{t('sampleScenario')}</Label>
      <Select value={value} onValueChange={handleChange}>
        <SelectTrigger className='w-72'>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {agreementSampleScenarios.map((option) => (
            <SelectItem key={option} value={option}>
              {t(`scenarios.${option}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
